import { render, staticRenderFns } from "./Shenpi.vue?vue&type=template&id=0158dc2e&scoped=true"
import script from "./Shenpi.vue?vue&type=script&lang=js"
export * from "./Shenpi.vue?vue&type=script&lang=js"
import style0 from "./Shenpi.vue?vue&type=style&index=0&id=0158dc2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0158dc2e",
  null
  
)

export default component.exports